export default __webpack_public_path__ + "static/media/Web Video.55a30fdb.MP4";